import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, Observable, of, Subject } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { DataResponse } from '../../../app/modules/mdr-dashboards/interfaces/mdr-dashboards.data-response.interface';

interface DataCategory {
    subcategories: string[];
    subcategoriesValues: number[];
}

@Pipe({
    name: 'removeAreaEmptyCategories',
    standalone: false,
})
export class RemoveAreaEmptyCategoriesPipe implements PipeTransform {
    constructor() {}

    transform(
        val: Observable<DataResponse>,
        deep: boolean = false,
        colors: string[],
        strokeColors: string[],
        isLoadedData: Subject<boolean>,
    ) {
        return isObservable(val)
            ? val.pipe(
                  map((data: DataResponse) => {
                      let emptyCategories = new Map<number, number>();
                      let emptyCategoriesIndexes: number[] = [];
                      /* Count all empty categories ( that have the value 0 )*/
                      for (let i = 0; i < data.data.length; i++) {
                          for (let j = 0; j < data.data[i].data.length; j++) {
                              if (!emptyCategories.get(i)) {
                                  if (data.data[i].data[j][1] === 0) {
                                      emptyCategories.set(i, 1);
                                  }
                              } else {
                                  if (data.data[i].data[j][1] === 0) {
                                      // @ts-ignore
                                      emptyCategories.set(i, emptyCategories.get(i) + 1);
                                  }
                              }
                          }
                      }

                      /* Check if entire colum for that category is 0 */
                      emptyCategories.forEach((value, key) => {
                          if (value === data.data[0].data.length) {
                              emptyCategoriesIndexes.push(key);
                          }
                      });
                      /* Remove all categories with 0 on the entire column */
                      for (let j = emptyCategoriesIndexes.length - 1; j >= 0; j--) {
                          for (let i = data.data.length - 1; i >= 0; i--) {
                              if (i === emptyCategoriesIndexes[j]) {
                                  data.data.splice(emptyCategoriesIndexes[j], 1);
                                  colors.splice(emptyCategoriesIndexes[j], 1);
                                  strokeColors.splice(emptyCategoriesIndexes[j], 1);
                              }
                          }
                      }
                      isLoadedData.next(true);
                      // @ts-ignore
                      return {
                          loading: false,
                          data: data,
                          error: null,
                          hasNoResults: data.data.length === 0,
                      };
                  }),
                  startWith({
                      loading: true,
                      data: null,
                      error: null,
                      hasNoResults: true,
                  }),
                  catchError((error) => {
                      return of({
                          loading: false,
                          error,
                          data: null,
                          hasNoResults: true,
                      });
                  }),
              )
            : val;
    }
}
